var map = {
	"./Ashoka/AshokaFeather.json": [
		634,
		3
	],
	"./AshokaMinion/AshokaMinionParticleImpact.json": [
		635,
		4
	],
	"./AshokaMinion/AshokaMinionParticleWave.json": [
		636,
		5
	],
	"./AshokaMinion/smoke.json": [
		637,
		6
	],
	"./Bjorn/BjornAxe.json": [
		589,
		7
	],
	"./Bjorn/BjornCircle.json": [
		590,
		8
	],
	"./Bjorn/BjornE.json": [
		591,
		9
	],
	"./Bjorn/BjornN.json": [
		592,
		10
	],
	"./Bjorn/BjornNE.json": [
		593,
		11
	],
	"./Bjorn/BjornNW.json": [
		594,
		12
	],
	"./Bjorn/BjornS.json": [
		595,
		13
	],
	"./Bjorn/BjornSE.json": [
		596,
		14
	],
	"./Bjorn/BjornSW.json": [
		597,
		15
	],
	"./Bjorn/BjornW.json": [
		598,
		16
	],
	"./Celeste/CelesteCloudBack.json": [
		586,
		17
	],
	"./Celeste/CelesteCloudFront.json": [
		587,
		18
	],
	"./Celeste/CelesteGroundHitParticle.json": [
		588,
		19
	],
	"./Data.json": [
		1221,
		129
	],
	"./Dmitri/DmitriArrow.json": [
		638,
		20
	],
	"./Dmitri/IceSpike1.json": [
		639,
		21
	],
	"./Dmitri/IceSpike2.json": [
		640,
		22
	],
	"./Dmitri/IceSpike3.json": [
		641,
		23
	],
	"./Dmitri/SpikeImpactDust.json": [
		642,
		24
	],
	"./Dmitri/SpikeImpactParticle.json": [
		643,
		25
	],
	"./Dmitri/StompImpact.json": [
		644,
		26
	],
	"./Dmitri/StompImpactDust.json": [
		645,
		27
	],
	"./Dmitri/StompImpactParticle.json": [
		646,
		28
	],
	"./Gustav/GustavAttackPortal.json": [
		647,
		29
	],
	"./Gustav/GustavDustParticleBackLeft.json": [
		648,
		30
	],
	"./Gustav/GustavDustParticleBackRight.json": [
		649,
		31
	],
	"./Gustav/GustavDustParticleFrontLeft.json": [
		650,
		32
	],
	"./Gustav/GustavDustParticleFrontRight.json": [
		651,
		33
	],
	"./Gustav/GustavEmberParticle.json": [
		652,
		34
	],
	"./Gustav/GustavFinalAttackPortal.json": [
		653,
		35
	],
	"./Gustav/GustavFinalDustParticleBackLeft.json": [
		654,
		36
	],
	"./Gustav/GustavFinalDustParticleBackRight.json": [
		655,
		37
	],
	"./Gustav/GustavFinalDustParticleFrontLeft.json": [
		656,
		38
	],
	"./Gustav/GustavFinalDustParticleFrontRight.json": [
		657,
		39
	],
	"./Gustav/GustavFinalGroundHitParticle.json": [
		658,
		40
	],
	"./Gustav/GustavFinalSwordParticle.json": [
		659,
		41
	],
	"./Gustav/GustavGroundHitParticle.json": [
		660,
		42
	],
	"./Gustav/GustavSwordParticle.json": [
		661,
		43
	],
	"./Gustav/smoke.json": [
		662,
		44
	],
	"./Jin/Jin-RightWaterSplash.json": [
		599,
		45
	],
	"./Jin/Jin_HydropumpImpact.json": [
		600,
		46
	],
	"./Jin/Jin_LeftWaterSplash.json": [
		601,
		47
	],
	"./Jin/Jin_WaterErupt.json": [
		602,
		48
	],
	"./Jin/Jin_WaterEruptParticle.json": [
		603,
		49
	],
	"./Nesha/LaserParticle_1.json": [
		604,
		50
	],
	"./Nesha/LaserParticle_2.json": [
		605,
		51
	],
	"./Nesha/LaserParticle_3.json": [
		606,
		52
	],
	"./Nesha/LaserParticle_4.json": [
		607,
		53
	],
	"./Nesha/LaserParticle_5.json": [
		608,
		54
	],
	"./Nesha/LaserParticle_6.json": [
		609,
		55
	],
	"./Nesha/LaserParticle_7.json": [
		610,
		56
	],
	"./Nesha/Laser_1.json": [
		611,
		57
	],
	"./Nesha/Laser_2.json": [
		612,
		58
	],
	"./Nesha/Laser_3.json": [
		613,
		59
	],
	"./Nesha/Laser_4.json": [
		614,
		60
	],
	"./Nesha/Laser_5.json": [
		615,
		61
	],
	"./Nesha/Laser_6.json": [
		616,
		62
	],
	"./Nesha/Laser_7.json": [
		617,
		63
	],
	"./Nesha/Laser_8.json": [
		618,
		64
	],
	"./Nesha/Laser_9.json": [
		619,
		65
	],
	"./Nesha/Smoke.json": [
		620,
		66
	],
	"./Penguin/Borris.json": [
		663,
		67
	],
	"./Penguin/Kelvin.json": [
		664,
		68
	],
	"./Penguin/Robert.json": [
		665,
		69
	],
	"./Penguin/smoke.json": [
		666,
		70
	],
	"./Robin/arrow.json": [
		1220,
		71
	],
	"./Shaka/DmitriArrow.json": [
		1222,
		130
	],
	"./Shaka/IceSpike1.json": [
		1223,
		131
	],
	"./Shaka/IceSpike2.json": [
		1224,
		132
	],
	"./Shaka/IceSpike3.json": [
		1225,
		133
	],
	"./Shaka/SpikeImpactDust.json": [
		1226,
		134
	],
	"./Shaka/SpikeImpactParticle.json": [
		1227,
		135
	],
	"./Shaka/StompImpact.json": [
		1228,
		136
	],
	"./Shaka/StompImpactDust.json": [
		1229,
		137
	],
	"./Shaka/StompImpactParticle.json": [
		1230,
		138
	],
	"./ShakaMinion/weapon.json": [
		1231,
		139
	],
	"./Tenko/TenkoBall_1.json": [
		667,
		72
	],
	"./Tenko/TenkoBall_2.json": [
		668,
		73
	],
	"./Tenko/TenkoBall_3.json": [
		669,
		74
	],
	"./Tenko/Tenko_Blast1.json": [
		670,
		75
	],
	"./Tenko/Tenko_Blast2.json": [
		671,
		76
	],
	"./TenkoMinion/Aka.json": [
		672,
		77
	],
	"./TenkoMinion/Aki.json": [
		673,
		78
	],
	"./TenkoMinion/Aku.json": [
		674,
		79
	],
	"./TenkoMinion/smoke.json": [
		675,
		80
	],
	"./Vonder/acorn.json": [
		579,
		81
	],
	"./Vonder/acornLoop.json": [
		580,
		82
	],
	"./Vonder/acornReal.json": [
		581,
		83
	],
	"./Vonder/innerPortal.json": [
		582,
		84
	],
	"./Vonder/innerPortalLoop.json": [
		583,
		85
	],
	"./Vonder/outerPortal.json": [
		584,
		86
	],
	"./Vonder/outerPortalLoop.json": [
		585,
		87
	],
	"./Wendy/acorn.json": [
		621,
		88
	],
	"./Wendy/acornLoop.json": [
		622,
		89
	],
	"./Wendy/acornReal.json": [
		623,
		90
	],
	"./Wendy/innerPortal.json": [
		624,
		91
	],
	"./Wendy/innerPortalLoop.json": [
		625,
		92
	],
	"./Wendy/outerPortal.json": [
		626,
		93
	],
	"./Wendy/outerPortalLoop.json": [
		627,
		94
	],
	"./Yamato/Blast1.json": [
		628,
		95
	],
	"./Yamato/Blast2.json": [
		629,
		96
	],
	"./Yamato/Fireball.json": [
		630,
		97
	],
	"./Yamato/Firework1.json": [
		631,
		98
	],
	"./Yamato/Firework2.json": [
		632,
		99
	],
	"./Yamato/Fireworkstart.json": [
		633,
		100
	],
	"./bandits_blade.json": [
		1232,
		140
	],
	"./explosion.json": [
		1233,
		141
	],
	"./sakura.json": [
		1234,
		142
	],
	"./smoke.json": [
		1235,
		143
	],
	"./test.json": [
		1236,
		144
	],
	"./testConfig.json": [
		1237,
		145
	],
	"./testConfig2.json": [
		1238,
		146
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1176;
module.exports = webpackAsyncContext;